import { render, staticRenderFns } from "./ConsultComplete.vue?vue&type=template&id=0b569a82&"
import script from "./ConsultComplete.vue?vue&type=script&lang=js&"
export * from "./ConsultComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports